export const baseURL = "https://ead.howyin.com/";
export const secretKey = "eadBKdFyJqAQfMPM1w2t-hae33f8f26659@Hwy3kPx9";
export const projectName = "Howyin";

// Helper to normalize image URLs to use current baseURL
export const normalizeImageUrl = (url) => {
  if (!url) return null;
  // Handle base64 images
  if (url.startsWith('data:') || url.startsWith('/9j/') || url.startsWith('iVBOR')) {
    if (url.startsWith('/9j/') || url.startsWith('iVBOR')) {
      return `data:image/jpeg;base64,${url}`;
    }
    return url;
  }
  // Replace production URLs with current baseURL
  const productionUrls = [
    'https://console.howyinserver.com/',
    'http://console.howyinserver.com/',
  ];
  for (const prodUrl of productionUrls) {
    if (url.startsWith(prodUrl)) {
      return url.replace(prodUrl, baseURL);
    }
  }
  return url;
};
